import React from "react";
import { Button } from "antd";
import { EyeOutlined, CloseOutlined } from "@ant-design/icons";
import { getImpersonatedUser, clearImpersonatedUser } from "../js/impersonation";

export default function ImpersonationBanner() {
  const impersonated = getImpersonatedUser();
  if (!impersonated) return null;

  const stop = () => {
    clearImpersonatedUser();
    window.location.reload();
  };

  return (
    <div
      role="status"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        background: "#fff7e6",
        borderBottom: "1px solid #ffd591",
        color: "#874d00",
        padding: "6px 16px",
        display: "flex",
        alignItems: "center",
        gap: 12,
        fontSize: 13,
        fontWeight: 500,
      }}
    >
      <EyeOutlined />
      <span>
        Viewing as{" "}
        <strong>{impersonated.email || impersonated.uid}</strong>
        {impersonated.email && (
          <span style={{ marginLeft: 8, color: "#ad6800", fontWeight: 400 }}>
            ({impersonated.uid})
          </span>
        )}
      </span>
      <span style={{ flex: 1 }} />
      <Button size="small" icon={<CloseOutlined />} onClick={stop}>
        Stop viewing
      </Button>
    </div>
  );
}
